// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"8b8cdcbe","478":"f5f23349","787":"9eaa9f11","915":"cc8d00ef"}[chunkId] + ".chunk.js";
};